<template>
    <div id="fixed-progress-bar" class="progress-bar-container">
        <div class="progress">
            <div id="progress-bar" class="progress-bar" role="progressbar">
            </div>
        </div>
        <div class="progress-meta">
            <div class="pull-right">
                <span id="progress-bar-meta">0%</span> Completed
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'progress-bar',
    methods: {
        handleScroll() {
            let beingPersonalizingEl = document.getElementById('begin-personalizing');

            if (beingPersonalizingEl && beingPersonalizingEl.offsetHeight && beingPersonalizingEl.offsetTop) {
                let beginPersonalizingHeight = beingPersonalizingEl.offsetHeight + beingPersonalizingEl.offsetTop;
                let scrollTop = window.pageYOffset;

                if (beginPersonalizingHeight <= scrollTop) {
                    document.getElementById('fixed-progress-bar').style.top = this.menuHeight;
                } else {
                    document.getElementById('fixed-progress-bar').style.top = '-75px';
                }
            }
        },
    },
    data() {
        return {
            menuHeight: document.getElementById('masthead').clientHeight + 'px'
        }
    },
    props: {},
    mounted() {
        window.addEventListener('scroll', this.handleScroll);

    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
</script>

<style lang="scss" scoped>

    .progress-bar-container {
        position:fixed;
        top:-75px;
        left:0;
        height:75px;
        width:100%;
        background:#efefef;
        z-index:102;
        padding:20px 0 0 0;
        border-bottom: 1px solid #dfdfdf;
        transition: top 650ms;

        .progress {
            width:100%;
            max-width:720px;
            margin:0 auto;
            height:15px;

            .progress-bar {
                width:0;
                background:#6ac425;
            }
        }

        .progress-meta {
            margin:0 auto;
            height:30px;
            width:100%;
            max-width:720px;
            padding: 5px 2px 0 0;
            font-size:14px;
        }
    }

</style>